
import Header from "@/pages/marketing/components/Header";
import Footer from "@/pages/marketing/components/Footer";
import ContactForm from "@/components/contact/ContactForm";
import ContactInfo from "@/components/contact/ContactInfo";
import PageSEO from "@/components/seo/PageSEO";
import StructuredData from "@/components/seo/StructuredData";

const ContactPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <PageSEO
        title="Contact GoDyspo | Get Help"
        description="Have questions about GoDyspo? We're here to help. Reach out to our support team and we'll respond as soon as possible."
        canonical="/contact"
      />
      <StructuredData 
        type="BreadcrumbList" 
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Contact", url: "/contact" }
        ]} 
      />
      <Header />
      
      <main className="flex-1 py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">Contact Us</h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Have questions about GoDyspo? We're here to help. Reach out to us and we'll respond as soon as possible.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <ContactForm />
            <ContactInfo />
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ContactPage;
